import { PARENT_CHILD_REFERENCE } from '@ardoq/global-consts';
import { isParentChildReferenceModelId } from '@ardoq/graph';
import type { RelationshipsLink, RelationshipsNode } from '../types';

export const getMatchingFilterIdsFilter =
  (ids: Set<string>) => (item: RelationshipsNode | RelationshipsLink) =>
    item.modelId && item.matchingFilterIds?.some(id => ids.has(id));

export const getReferenceTypesFilter = (referenceTypeIdGroups: string[][]) => {
  const referenceTypeIds = new Set(referenceTypeIdGroups.flat());
  return (link: RelationshipsLink) => {
    if (link.globalTypeId === null) {
      return (
        isParentChildReferenceModelId(link.modelId) &&
        referenceTypeIdGroups.some(globalTypeIds =>
          globalTypeIds.includes(PARENT_CHILD_REFERENCE)
        )
      );
    }
    return referenceTypeIds.has(link.globalTypeId);
  };
};

export const simpleHash = (str: string) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash &= hash; // Convert to 32bit integer
  }

  return hash;
};
